// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","content":"qr-code_content__QXNda","qr":"qr-code_qr__3Gsso","share":"qr-code_share__q7k+H","icons":"qr-code_icons__mhIPf"};